// extracted by mini-css-extract-plugin
export default {"buttonSpacer":"_2Wo3EwT7x2frNMe4uuCoh5"};